import { render, staticRenderFns } from "./twoColumnBlock.vue?vue&type=template&id=412fb293&scoped=true&"
import script from "./twoColumnBlock.vue?vue&type=script&lang=js&"
export * from "./twoColumnBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412fb293",
  null
  
)

export default component.exports